import React from "react";
import { cn } from "./cn";

/** Shimmering placeholder block. */
export const Skeleton = ({ className }) => (
  <div className={cn("animate-pulse rounded-md bg-gray-200 dark:bg-gray-700", className)} />
);

/** Skeleton that mirrors an event tile. */
export const EventCardSkeleton = () => (
  <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
    <Skeleton className="h-48 w-full rounded-none" />
    <div className="p-5 space-y-3">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="h-5 w-3/4" />
      <Skeleton className="h-4 w-full" />
      <Skeleton className="h-4 w-1/2" />
      <div className="pt-3 flex justify-between">
        <Skeleton className="h-4 w-20" />
        <Skeleton className="h-4 w-16" />
      </div>
    </div>
  </div>
);

/** A responsive grid of event-card skeletons. */
export const EventGridSkeleton = ({ count = 6 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
    {Array.from({ length: count }).map((_, i) => <EventCardSkeleton key={i} />)}
  </div>
);

export default Skeleton;
